import { CustomAxiosRequestConfig } from "@/interfaces/customAxiosRequestConfig";
import { PaymentType } from "@/internal/modules/providers/interfaces/PaymentType";
import axios from "@/lib/axios";
import { useQuery } from "@tanstack/vue-query";
import { error } from "console";

interface Props {
  errorHandling?: boolean;
}

const getHotelBankPaymentTypes = async (
  errorHandling = false,
): Promise<PaymentType> => {
  const { data } = await axios.get<PaymentType>(
    "api/internal/bank-accounts/payment_types",
    {
      errorHandling,
    } as CustomAxiosRequestConfig,
  );

  return data;
};

const useHotelBankPaymentTypes = (props: Props = { errorHandling: false }) => {
  const { data, isLoading } = useQuery(["hotelBankPaymentTypes"], () =>
    getHotelBankPaymentTypes(props.errorHandling),
  );

  return {
    hotelBankPaymentTypes: data,
    isLoading,
  };
};

export default useHotelBankPaymentTypes;
